import { ComboboxItem } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { clinicQKeys } from "./queryKeys";


interface QueryProps {
  isEnabled?: boolean;
}

const queryFn = () => {
  return api.get("clinic/collection-methods");
};

const select = (res: any) => {
  if (Array.isArray(res.data) && res.data.length) {
    const newData: ComboboxItem[] = [];

    for (const item of res.data) {
      const { collection_method, _id } = item;

      newData.push({
        label: collection_method as string,
        value: _id as string
      });
    }

    return newData;
  }
  return [];
};

export const useGetClinicCollectionMethodsOptions = ({
  isEnabled = true,
}: QueryProps = {}) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: clinicQKeys.collectionMethods(),
    queryFn: queryFn,
    select,
    staleTime: Infinity,
    enabled: isEnabled,

    onError: (res: any) => {
      console.error("[From Get Clinic Collection Methods Options]", res);
      handleErrors(res, "query");
    },
  });
};
